import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ErroNotificacaoService } from '../erro-notificacao.service';
import { environment } from 'src/environments/environment';
import { LoginPermissao } from '../model/LoginPermissao';
import { Login } from '../model/Login';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  aguardeDialog = false;
  jwtPayLoad: any;

  oauthTokenURL: string;
  removerToken: string;
  loginUrl: string;
  loginConveinoURL: string;

  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
    private erroHandle: ErroNotificacaoService,
    private toasty: ToastrService,
    private rota: Router
  ) {
    this.oauthTokenURL = `${environment.apiUrl}/oauth/token`;
    this.removerToken = `${environment.apiUrl}/tokens/revoke`;
    this.loginUrl = `${environment.apiUrl}/logins`;
    this.loginConveinoURL = `${environment.apiUrl}/logins-convenios`;
  }  

  login(usuario: string, senha: string) {
    const body = `username=${usuario}&password=${senha}&grant_type=password`;
    const httpheaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic eG1hbmFnZXI6dmFuODUxMSo='
      })
    };
    this.aguardeDialog = true;
    return this.http.post(`${this.oauthTokenURL}`, body, httpheaders).subscribe(
      (dados: any) => {
        this.armazenarToken(dados.access_token);
        this.rota.navigate(['/dashboard']);
        this.aguardeDialog = false;
      }, erro => {
        if (erro.status === 400) {
          if (erro.error.error === 'invalid_grant') {
            this.aguardeDialog = false;
            return this.toasty.error('USUÁRIO OU SENHA INVÁLIDO!', 'ATENÇÃO!');
          }
        }
        this.aguardeDialog = false;
        return this.erroHandle.handle(erro);
      });
  }

  renovarLogin(usuario: string, senha: string) {
    const body = `username=${usuario}&password=${senha}&grant_type=password`;
    const httpheaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic eG1hbmFnZXI6dmFuODUxMSo='
      })};
    return this.http.post(`${this.oauthTokenURL}`, body, httpheaders);
  }

  armazenarToken(token: string) {
    localStorage.setItem('access_token_xmanager', token);
    this.jwtPayLoad = this.jwtHelper.decodeToken(token);
  }

  carregarToken() {
    const token = localStorage.getItem('access_token_xmanager');
    if (token) {
      this.armazenarToken(token);
    }
  }

  isAccessTokenInvalido() {
    const token = localStorage.getItem('access_token_xmanager');
    return !token || this.jwtHelper.isTokenExpired(token);
  }

  limparAccessToken() {
    const token = localStorage.getItem('access_token_xmanager');
    localStorage.removeItem('access_token_xmanager');
    localStorage.clear();
    const httpheaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.delete(`${this.removerToken}`, httpheaders);
  }

  buscarLoginPorId(idFuncionario: number, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.get(`${this.loginUrl}/${idFuncionario}`, httpHeaders);
  }

  buscarPermissoes(token: any) {
    const httpHeaders ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.get(`${this.loginUrl}/permissoes`, httpHeaders);
  }

  buscarConvenioLoginPorId(idConvenio: number, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.get(`${this.loginConveinoURL}/${idConvenio}`, httpHeaders);
  }

  buscarConvenioPermissoes(token: any) {
    const httpHeaders ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.get(`${this.loginConveinoURL}/permissoes-convenios`, httpHeaders);
  }

  criarLogin(loginUsuario: Login, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.post(`${this.loginUrl}`,loginUsuario,httpHeaders);
  }

  editarLogin(loginUsuario: Login, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.put(`${this.loginUrl}/${loginUsuario.id}`,loginUsuario,httpHeaders);
  }

  buscarLoginPorLogin(strLogin: string, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }),
      params: new HttpParams()
      .set('strLogin',strLogin) 
    }
    return this.http.get(`${this.loginUrl}/login-login`, httpHeaders);    
  }

  buscarLoginPorLoginConvenio(strLogin: string, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }),
      params: new HttpParams()
      .set('strLogin',strLogin) 
    }
    return this.http.get(`${this.loginConveinoURL}/login-login`, httpHeaders);    
  }

  criarPermissao(loginPermissao: LoginPermissao, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.post(`${this.loginUrl}/login-permissao`,loginPermissao,httpHeaders);
  }

  deletarPermissao(loginPermissao: LoginPermissao, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.delete(`${this.loginUrl}/${loginPermissao.idLogin}/${loginPermissao.idPermissao}`, httpHeaders);
  }
}
